// 文件处理相关的工具函数

/**
 * 获取文件内容（通过Blob）
 * @param {string} fileUrl - 文件URL
 * @returns {Promise<string>} 文件内容
 */
export async function fetchFileContent(fileUrl) {
    try {
        // 构建正确的URL
        let requestUrl = fileUrl
        if (process.env.NODE_ENV === 'development') {
            // 开发环境：如果是相对路径，保持原样让代理处理
            if (!fileUrl.startsWith('http')) {
                requestUrl = fileUrl
            }
        } else {
            // 生产环境：如果是相对路径，添加完整URL
            if (!fileUrl.startsWith('http')) {
                requestUrl = `https://demo-table.buzigai.com/api${fileUrl}`
            }
        }

        console.log('Fetching file content from:', requestUrl)

        const response = await fetch(requestUrl, {
            method: 'GET',
            headers: {
                'Accept': 'text/html,text/markdown,text/plain,*/*'
            }
        })

        if (!response.ok) {
            throw new Error(`HTTP错误: ${response.status} - ${response.statusText}`)
        }

        const blob = await response.blob()
        const text = await blob.text()

        console.log('File content loaded, length:', text.length)
        return text
    } catch (error) {
        console.error('Failed to fetch file content:', error)
        throw error
    }
}

/**
 * 下载文件到本地
 * @param {string} content - 文件内容
 * @param {string} filename - 文件名
 * @param {string} mimeType - MIME类型
 */
export function downloadFile(content, filename, mimeType = 'text/plain') {
    try {
        const blob = new Blob([content], { type: `${mimeType};charset=utf-8` })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = filename
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        URL.revokeObjectURL(url)
        return true
    } catch (error) {
        console.error('Download failed:', error)
        return false
    }
}

/**
 * HTML转义函数
 * @param {string} text - 需要转义的文本
 * @returns {string} 转义后的文本
 */
export function escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
}
